module.exports = __webpack_public_path__ + "static/media/conference.640fe3f2.svg";